<!--
✅ Loading
✅ List
-->
<template>
  <div>
    <div v-if="!ready">
      <blank></blank>
    </div>
    <div v-else>
      Cards: {{cards}}
      <div v-for="(c, index) in cards" :key="index">
        <b-row v-if="index == 0 || index % 3 == 0">
          <b-col cols="12" xl="4" v-if="cards[index]">
            <tile :tokenId="cards[index]"></tile>
          </b-col>
          <b-col cols="12" xl="4" v-if="cards[index+1]">
            <!-- <b-jumbotron :header="cards[index+1]['name']" :lead="(cards[index+1]['rate'] || '...') + '%'">
              <div class="w-100 text-right">
                <b-avatar button icon="arrow-right" disabled></b-avatar>
              </div>
            </b-jumbotron> -->
            <tile :tokenId="cards[index+1]"></tile>

          </b-col>
          <b-col cols="12" xl="4" v-if="cards[index+2]">
            <tile :tokenId="cards[index+2]"></tile>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>
<script>
import Tile from "@/components/marketplace/buy/tile.vue"
import Blank from "@/components/Blank.vue"
export default {
  components: { Tile, Blank },
  data() {
    return {
      loading: true,
      cards: []
    };
  },
  methods: {
    getTokens(){
        this.$store
        .dispatch("ethereum/listMembers")
        .then((n) => {
          this.cards = n
        })
        .catch((err) => {
          this.$bvToast.toast(err["message"] || err, {
            title: "Error",
            variant: "danger",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  mounted(){
    this.getTokens()
  }
};
</script>